"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceBannerWidget = exports.addBannerWidgets = void 0;
var WrongAnswerInFormBanner_1 = require("./WrongAnswerInFormBanner");
var RelatedCoverHeadsUpBannerWidget_1 = require("./RelatedCoverHeadsUpBannerWidget");
var LvToAllianzUKTransferBanner_1 = require("./LvToAllianzUKTransferBanner");
var MaintenanceBannerWidget_1 = require("./MaintenanceBannerWidget");
Object.defineProperty(exports, "MaintenanceBannerWidget", { enumerable: true, get: function () { return MaintenanceBannerWidget_1.MaintenanceBannerWidget; } });
var AddressChangeBanner_1 = require("./AddressChangeBanner");
var FutureMTAHeadUpBannerWidget_1 = require("./FutureMTAHeadUpBannerWidget");
var ReplaceCarStartDateWarningWidget_1 = require("./ReplaceCarStartDateWarningWidget");
var GdprBanner_1 = require("./GdprBanner");
var InfoBannerWidget_1 = require("./InfoBannerWidget");
var addBannerWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "wrongAnswerInFormBanner",
        component: WrongAnswerInFormBanner_1.WrongAnswerInFormBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "RelatedCoverHeadsUpBanner",
        component: RelatedCoverHeadsUpBannerWidget_1.RelatedCoverHeadsUpBannerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "lvToAllianzTransferTransferBannerWidget",
        component: LvToAllianzUKTransferBanner_1.LvToAllianzUKTransferBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addressChangeBanner",
        component: AddressChangeBanner_1.AddressChangeBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "futureMtaHeadUpPanel",
        component: FutureMTAHeadUpBannerWidget_1.FutureMTAHeadUpBannerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "replaceCarStartDateWarning",
        component: ReplaceCarStartDateWarningWidget_1.ReplaceCarStartDateWarningWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "gdprBanner",
        component: GdprBanner_1.GdprBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "infoBanner",
        component: InfoBannerWidget_1.InfoBannerWidget
    });
};
exports.addBannerWidgets = addBannerWidgets;
//# sourceMappingURL=index.js.map